import { call, put, delay } from "redux-saga/effects";
import { subscriptionAPI } from "@services/api";
import { isSubscribedAction, subscribeActions } from "../slices";
import { showFailureToast } from "@helpers";

function* subscribeWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(subscribeActions.pending());
    const response = yield call(subscriptionAPI.subscribe, payload);
    yield put(subscribeActions.success(response));
    yield put(isSubscribedAction(payload));

    // TODO: handle callback | onSuccess
  } catch (error) {
    showFailureToast("Subscribe Fail!");
    yield put(subscribeActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { subscribeWorker };
